import { render, staticRenderFns } from "./ReceiptCapture.vue?vue&type=template&id=8ed72dd8&scoped=true"
import script from "./ReceiptCapture.vue?vue&type=script&lang=js"
export * from "./ReceiptCapture.vue?vue&type=script&lang=js"
import style0 from "./ReceiptCapture.vue?vue&type=style&index=0&id=8ed72dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed72dd8",
  null
  
)

export default component.exports